import { render } from "./table-cell-color.vue?vue&type=template&id=2c568187"
import script from "./table-cell-color.vue?vue&type=script&lang=js"
export * from "./table-cell-color.vue?vue&type=script&lang=js"

import "./table-cell-color.vue?vue&type=style&index=0&id=2c568187&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__